import React from 'react';
import './Gallonround.css';

import GallonCapImg from '../../../imgs/Galloncaps.webp';
import roundsank from '../../../imgs/roundsank.webp';
const Gallonround = () => {
  return (
    <div className="gallon-container">
      <div className="gallon-card-container">

        <div className="gallon-card" data-aos="fade-down">
          <img src={GallonCapImg} alt="5 Gallon Cap Molding" className="gallon-img"/>
          <h3>5 Gallon Water Bottle Caps Molding</h3>
          <p>KII Series High Speed Injection Molding Machine for 5 Gallon Bottle Lid Production.</p>
        </div>

        <div className="gallon-card" data-aos="fade-down">
          <img src={roundsank} alt="PET Thin Wall Container" className="gallon-img" />
          <h3>PET Thin-Wall Container Solution</h3>
          <p>#Powerjet IMM PET1150-S6 for Special Packaging Container Round Snack Box.</p>
        </div>

      </div>
    </div>
  );
};

export default Gallonround;
